const convertToHash = async (string: string): Promise<string> => {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
};

export const getAvatarUrl = async (email: string): Promise<string | null> => {
  try {
    const hash = await convertToHash(email);
    const resp = await fetch(`https://gravatar.com/${hash}.json`);

    if (resp.ok) {
      return `https://gravatar.com/avatar/${hash}`;
    }

    return null;
  } catch (error) {
    console.warn("Could not load avatar from gravatar.com", error);
    return null;
  }
};
